'use strict'

import api from '../api'

import {
	LOGIN_BEGIN,
	LOGIN_FAILURE,
	LOGIN_SUCCESS,
	SET_USER,

	LOGOUT, REMOVE_USER
} from './types'

const ERROR_RESET = 'ERROR_RESET'

const initialState = {
	authenticating: false,
	user: null,

	error: false,
	errorMessage: null
}

export const ROLE_CURATOR = 'ROLE_CURATOR'
export const ROLE_ADMIN = 'ROLE_ADMIN'

const actions = {

	initialize({commit}) {
		// задаем начальное состояние store
		// потому этот метод первый

		// Решили работать с аутентификацией пользователя по сессии в cookie
		// чтобы проверить жива ли сессия нужно сделать какой-нибудь запрос к серверу,
		// например, спросить данные про текущего пользователя.
		// Оно и полезно - узнаем роли, членство в группах, что может влиять на UI.

		// Метод вызывается довольно много раз,
		// а конкретно при каждой проверке наличия аутентификации
		// при каждой загрузке компонента в router-view (ну и пусть)

		return api.auth.testLogin()
			.then(function ({data}) {
				// TODO: убрать копипаст из action login
				commit(SET_USER, data.user)
				if (!data.user) {
					throw 'No user'
				}
				let show_only_personals = false // TODO
				commit('runs/SET_SHOW_ONLY_PERSONALS', show_only_personals, {root: true})
			})
			.then(() => commit(LOGIN_SUCCESS))
			.catch(function (error) {
				commit(LOGOUT)
			})
	},

	login({commit}, {username, password, login_as_username}) {
		commit(LOGIN_BEGIN)
		return api.auth.login(username, password, login_as_username)
			.then(({data}) => {
				commit(SET_USER, data.user)
				if (!data.user) {
					throw 'No user'
				}
				let show_only_personals = false //TODO
				commit('runs/SET_SHOW_ONLY_PERSONALS', show_only_personals, {root: true})
			})
			.then(() => {
				commit(LOGIN_SUCCESS)
			})
			.catch(function (error) {
				commit(LOGIN_FAILURE, error)
				throw(error)
			})
	},
	logout({commit}) {
		return api.auth.logout()
			.then(() => {
				commit(LOGOUT)
				// TODO: Возможно, нужно ещё много чего почистить?
				commit('runs/UNCHECK_ALL', null, {root: true})
			})
			.finally(() => commit(REMOVE_USER))
	},

	error_reset({commit}) {
		commit(ERROR_RESET)
	},

	changePassword({a = {}}, {old_password, new_password}) {
		return api.auth.change_password(old_password, new_password)
	}
}

const mutations = {
	[LOGIN_BEGIN](state) {
		state.authenticating = true
		state.error = false
	},
	[LOGIN_FAILURE](state, error) {
		state.authenticating = false
		state.error = true

		let error_message = null
		try {
			error_message = error['response']['data']['detail']
		} catch {
		}

		if (error_message == null) {
			error_message = error
		}
		state.errorMessage = error_message
	},
	[LOGIN_SUCCESS](state) {
		state.authenticating = false
		state.error = false
		state.errorMessage = null
	},
	[LOGOUT](state) {
		state.user = null
		state.authenticating = false
		state.error = false
	},
	[SET_USER](state, user) {
		state.user = user
	},

	[REMOVE_USER](state) {
		state.user = null
	},

	[ERROR_RESET](state) {
		state.error = false
		state.errorMessage = null
	}

	// [SET_TOKEN](state, token) {
	//   localStorage.setItem(TOKEN_STORAGE_KEY, token);
	//   session.defaults.headers.Authorization = `Token ${token}`;
	//   state.token = token;
	// },
	// [REMOVE_TOKEN](state) {
	//   localStorage.removeItem(TOKEN_STORAGE_KEY);
	//   delete session.defaults.headers.Authorization;
	//   state.token = null;
	// },
}

export default {
	namespaced: true,

	state: initialState,

	getters: {
		isAuthenticated(state) {
			return !!state.user
		},

		user(state) {
			return state.user
		},

		fullname(state) {
			if (state.user) {
				return state.user.fullname
			} else {
				return null
			}
		},

		is_superuser(state) {
			if (state.user) {
				return state.user.is_superuser
			} else {
				return false
			}
		},

		is_curator(state) {
			if (state.user) {
				return state.user.curator_labs.length
			} else {
				return false
			}
		},

		/**
		 * хард-код (
		 * @param state
		 * @returns {*}
		 */
		is_epi(state) {
			if (state.user) {
				return state.user.user_labs.includes("epi")
			} else {
				return false
			}
		},

		error(state) {
			return state.error
		},

		errorMessage(state) {
			return state.errorMessage
		}
	},
	actions,
	mutations
}
